import { UtilityService } from '@eforall/common';
import { DialogService, GridSetup } from '@eforall/dashboard';
import { TopicRow } from '../topics-view.part';
import { getActions } from './get-actions';
import { getColumns } from './get-columns';
import { AcceleratorAreaService } from '../../../../accelerator-area.service';


export function getSetup(util: UtilityService, dialogService: DialogService, areaService: AcceleratorAreaService): GridSetup<TopicRow> {

	return {
		rowName: { singular: 'Topic', plural: 'Topics' },
		getRowKey: row => '' + row.accTopicId,
		stateKey: 'accelerator-topics-grid',
		actions: getActions(dialogService, areaService),
		buttons: [],
		columns: getColumns(util),
	}
}
